import { render, staticRenderFns } from "./AgencyMessageHistorySection.vue?vue&type=template&id=4e6ddae8&scoped=true"
import script from "./AgencyMessageHistorySection.vue?vue&type=script&lang=js"
export * from "./AgencyMessageHistorySection.vue?vue&type=script&lang=js"
import style0 from "./AgencyMessageHistorySection.vue?vue&type=style&index=0&id=4e6ddae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6ddae8",
  null
  
)

export default component.exports